"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AddressPickListAdapter = _interopRequireDefault(require("./AddressPickListAdapter"));

var _AgencyPickListAdapter = _interopRequireDefault(require("./AgencyPickListAdapter"));

var _CheckboxAdapter = _interopRequireDefault(require("./CheckboxAdapter"));

var _CheckboxGroupAdapter = _interopRequireDefault(require("./CheckboxGroupAdapter"));

var _CurrencyAdapter = _interopRequireDefault(require("./CurrencyAdapter"));

var _DatePickerAdapter = _interopRequireDefault(require("./DatePickerAdapter"));

var _EmailAdapter = _interopRequireDefault(require("./EmailAdapter"));

var _HtmlAdapter = _interopRequireDefault(require("./HtmlAdapter"));

var _MetaAdapter = _interopRequireDefault(require("./MetaAdapter"));

var _NumberAdapter = _interopRequireDefault(require("./NumberAdapter"));

var _PasswordAdapter = _interopRequireDefault(require("./PasswordAdapter"));

var _RadioGroupAdapter = _interopRequireDefault(require("./RadioGroupAdapter"));

var _SelectAdapter = _interopRequireDefault(require("./SelectAdapter"));

var _TelephoneAdapter = _interopRequireDefault(require("./TelephoneAdapter"));

var _TextAdapter = _interopRequireDefault(require("./TextAdapter"));

var _TextAreaAdapter = _interopRequireDefault(require("./TextAreaAdapter"));

var _TiledCheckboxAdapter = _interopRequireDefault(require("./TiledCheckboxAdapter"));

var _TiledRadioAdapter = _interopRequireDefault(require("./TiledRadioAdapter"));

var _TimePickerAdapter = _interopRequireDefault(require("./TimePickerAdapter"));

var _ReadOnlyAdapter = _interopRequireDefault(require("./ReadOnlyAdapter"));

var _ComboBoxAdapter = _interopRequireDefault(require("./ComboBoxAdapter"));

var _WholeNumberAdapter = _interopRequireDefault(require("./WholeNumberAdapter"));

var _ScoreAdapter = _interopRequireDefault(require("./ScoreAdapter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  'address-picklist': _AddressPickListAdapter.default,
  'agency-picklist': _AgencyPickListAdapter.default,
  checkbox: _CheckboxAdapter.default,
  'checkbox-group': _CheckboxGroupAdapter.default,
  currency: _CurrencyAdapter.default,
  'date-picker': _DatePickerAdapter.default,
  email: _EmailAdapter.default,
  hidden: _MetaAdapter.default,
  html: _HtmlAdapter.default,
  meta: _MetaAdapter.default,
  number: _NumberAdapter.default,
  password: _PasswordAdapter.default,
  radio: _RadioGroupAdapter.default,
  select: _SelectAdapter.default,
  tel: _TelephoneAdapter.default,
  text: _TextAdapter.default,
  textarea: _TextAreaAdapter.default,
  'tiled-radio': _TiledRadioAdapter.default,
  'tiled-checkbox-group': _TiledCheckboxAdapter.default,
  'time-picker': _TimePickerAdapter.default,
  readonly: _ReadOnlyAdapter.default,
  'combo-box': _ComboBoxAdapter.default,
  'whole-number': _WholeNumberAdapter.default,
  score: _ScoreAdapter.default
};
exports.default = _default;
//# sourceMappingURL=index.js.map